export const DEFAULT_AUDIT_LOGS_ITEMS_PAGE_NUMBER = 10;
